<div class="loader-container" *ngIf="!view">
  <app-loading-dots size="5px"></app-loading-dots>
</div>
<div class="account-select" *ngIf="view">
  <div
    class="right-buttom-menu"
    *ngIf="scaffoldType && scaffoldType !== 'sis-archive'">
    <p-button variant="text" (click)="exportEnrollments()" severity="link">
      <i class="far fa-file-export"></i>
      <span style="padding-left: 5px">
        {{ 'download_enrollments_csv' | translation }}
      </span>
    </p-button>
  </div>
  <div>
    <app-view [items]="view?.data?.content" [info]="view?.data"></app-view>
  </div>
</div>
